import React from 'react';
import PropTypes from 'prop-types';

class SwitchButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        try {
            const { 'data-testid': dataTestId } = this.props;
            const mode = (['switch', 'select'].indexOf(this.props.mode) < -1) ? 'switch' : this.props.mode;

            const id = (this.props.id.length > 0) ? this.props.id : this.props.name;

            const classes = [
                'switch-button',
                `switch-button-mode-${mode}`,
                this.props.theme,
                this.props.disabled ? ' disabled' : '',
                !!this.props.isSportTypeToggleSwitch ? 'isSportTypeSwitchToggle' : '',
            ];

            const label = () => {
                if (this.props.label.length > 0) {
                    return (
                        <label htmlFor={id}>{this.props.label}</label>
                    );
                }

                return null;
            };

            const labelRight = () => {
                if (this.props.labelRight.length > 0) {
                    return (
                        <label htmlFor={id}>{this.props.labelRight}</label>
                    );
                }

                return null;
            };

            return (
                <div className={classes.join(' ').trim()} data-testid={dataTestId || undefined}>
                    {label()}
                    <input
                        onChange={!this.props.disabled ? this.props.onChange : null}
                        checked={this.props.checked}
                        disabled={this.props.disabled}
                        id={id}
                        name={this.props.name}
                        type="checkbox"
                        value="1"
                        data-testid={dataTestId && `${dataTestId}.input`}
                    />
                    <label htmlFor={id} />
                    {labelRight()}
                </div>
            );
        } catch (e) {
            console.log('ERROR', 'render', e);
        }
    }
}

SwitchButton.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    labelRight: PropTypes.string,
    disabled: PropTypes.bool,
    theme: PropTypes.string,
    checked: PropTypes.bool,
    mode: PropTypes.string,
    onChange: PropTypes.func,
    'data-testid': PropTypes.string,
};

SwitchButton.defaultProps = {
    id: '',
    name: 'switch-button',
    label: '',
    labelRight: '',
    disabled: false,
    theme: 'switch-button-flat-round',
    checked: false,
    mode: 'switch',
    onChange: () => { },
    'data-testid': null,
};

export default SwitchButton;
